export enum DeviceStatistics {
  impressions = "impressions",
  clicks      = "clicks",
  conversions = "conversions",
  cost        = "cost",
}
